export const ADD_SEARCH_CONSOLE_PROPERTY_NAME = "add_search_console_property";
export const ADD_SEARCH_CONSOLE_PROPERTY_DESC = `Registers a Google Search Console property to the current workspace so Index Workers can use it.

Call this tool when the user asks to add/register a Search Console property in workspace settings (Settings > Search Console properties).
Examples: "How do I add a Search Console property?" / "Add a Search Console property"

Important:
- If the user wants to register a property but doesn't specify which one, call this tool with an empty input. The confirmation UI will fetch the list of available properties and let the user pick.
- Do not ask the user to manually provide the property/type before calling this tool unless there is no workspace context.

Input:
- 'workspaceId' (optional): Organization (workspace) ID. If omitted, the confirmation UI will fill it from the current URL.
- 'property' (optional): Search Console property string (e.g. 'https://example.com/' or 'sc-domain:example.com'). If omitted, pick one in the confirmation UI.
- 'type' (optional): 'USER' | 'SERVICE_ACCOUNT'. If omitted, it will be inferred from the selected option in the confirmation UI.
- 'serviceAccountId' (optional): Service account ID. Required for 'SERVICE_ACCOUNT'. If omitted, pick one in the confirmation UI and it will be filled automatically.

Output:
- Returns the registered property string plus 'settingsPath'/'settingsUrl' to open the settings page.

Notes:
- This is a write operation; always run through the confirmation UI.`;
